import type { ReactNode } from 'react';

interface PageHeaderBlockProps {
  title: string;
  subtitle?: string;
  size?: number;
  showActions?: boolean;
  actions?: ReactNode;
}

export default function PageHeaderBlock({
  title,
  subtitle,
  size = 36,
  showActions = false,
  actions,
}: PageHeaderBlockProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex-1">
        {/* Title */}
        <h1 
          className="font-bold" 
          style={{ fontSize: `${size}px`, lineHeight: `${size + 8}px` }}
        >
          {title}
        </h1>

        {/* Subtitle/Description */}
        {subtitle && (
          <p className="text-sm text-muted-foreground leading-[1.5]">{subtitle}</p>
        )}
      </div>

      {/* Actions */}
      {showActions && actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
}
